<template>
  <v-row>
    <v-col>
      <v-list dense color="color_bordered">
        <MyListItem :value="commande.sb" :name="$t('commande.sb')" />
        <!--        <MyListItem-->
        <!--          :value="commande.acheteur"-->
        <!--          :name="$t('commande.acheteur')"-->
        <!--        />-->
        <MyListItem :value="commande.date" :name="$t('commande.date')" />

        <!--        <MyListItem :value="commande.marche" :name="$t('commande.marche')" />-->
        <MyListItem
          :value="commande.fournisseur"
          :name="$t('commande.fournisseur')"
        />
        <MyListItem :value="commande.ghp" :name="$t('commande.ghp')" />
        <v-list-item>
          <v-list-item-content>{{ $t("commande.ged") }}</v-list-item-content>
          <v-list-item-content class="text-left">
            <v-row>
              <v-btn
                color="color_action"
                class="ml-1"
                icon
                link
                :href="getUrlGed()"
                target="_blank"
              >
                <v-icon>mdi-link</v-icon>
              </v-btn>
              <v-spacer />
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-col>
    <v-col>
      <v-list dense color="color_bordered">
        <MyListItem
          :value="commande.quantite"
          :name="$t('commande.quantite')"
        />
        <MyListItem
          :value="nbMonnaie(commande.prix)"
          :name="$t('commande.prix')"
        />
        <MyListItem
          :value="nbMonnaie(commande.montant)"
          :name="$t('commande.montant.initial')"
        />
        <MyListItem
          :value="nbMonnaie(commande.montant_restant)"
          :name="$t('commande.montant.restant')"
        />
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
import MyListItem from "@/components/core/MyListItem";
import { libUtilMixin } from "@/mixins/libUtilMixin";
import { URLGED } from "@/common/variables";

export default {
  name: "VueShowCommandDetail",
  components: {
    MyListItem,
  },
  mixins: [libUtilMixin],
  props: {
    commande: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getUrlGed() {
      return (
        URLGED +
        "/commande?commande__structure=" +
        this.commande.numero +
        "__" +
        this.commande.sb_ged
      );
    },
  },
};
</script>

<style scoped></style>
